import { useQuery } from '@apollo/client';
import { GET_USERS } from '../graphql/queries';
import { GET_TEAM } from '../graphql/teams';
import { getTeamPropertyManagers, resolveDisplayPropertyManagers } from '../utils/propertyManagers';

export default function usePropertyManagementDisplay(property) {
  const teamId = property?.propertyManagementTeamId || property?.propertyManagementTeam?.id;
  const parsedTeamId = Number(teamId);
  const hasTeamId = Number.isFinite(parsedTeamId) && parsedTeamId > 0;
  const { data: usersData } = useQuery(GET_USERS, {
    skip: !property,
    errorPolicy: 'ignore',
  });
  const { data: teamData } = useQuery(GET_TEAM, {
    variables: { id: parsedTeamId },
    skip: !hasTeamId,
    errorPolicy: 'ignore',
  });
  const users = usersData?.users || [];
  const team = teamData?.team || property?.propertyManagementTeam || null;
  return {
    team,
    managers: resolveDisplayPropertyManagers({
      property,
      users,
      teamMembers: getTeamPropertyManagers(team),
    }),
  };
}
